import { render } from "./RuiHeartRate.vue?vue&type=template&id=4651b955"
const script = {}
script.render = render

export default script